import { KYMW5900Model } from '../kymw5900.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWS企画商品一覧表を取得するサービス
 *
 * @export getCwsPlanGoodsListService
 * @class GetCwsPlanGoodsListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCwsPlanGoodsListService extends PlessJsonResponderSub<any> {

  vo = {
    orderCode: '',
    classCode: '',
    mediumType: '',
    entryGoodsDiv: '',
    coopCodeList: []
  };

  // 処理に使用するModel
  private model: KYMW5900Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsPlanGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CwsPlanGoodsList: {
          condition: {
            OrderCode: this.vo.orderCode,
            ClassCode: this.vo.classCode,
            MediumType: this.vo.mediumType,
            EntryGoodsDiv: this.vo.entryGoodsDiv,
          },
          combination: this.vo.coopCodeList.map(coopCode => {
            return {
              parameter: {
                CoopCode: coopCode
              }
            }
          })
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsPlanGoodsListService
   */
  execute(model: KYMW5900Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsPlanGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsPlanGoodsListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileName(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
